export default __webpack_public_path__ + "static/media/steps-check.19aea406.svg";